import { createAsyncThunk } from '@reduxjs/toolkit'
import { decamelizeKeys } from 'humps'
import { setAtmHash } from 'redux/slices/onboarding-slice'
import railsApiService from 'services/api/rails-api-service'
import { getCookies } from 'utils/cookieHelpers'

interface CheckEmailAvailabilityParams {
  email: string
  firstName: string
  lastName: string
  ssn: string
  phoneNumber: string
  source: 'academy' | 'consultation' | 'phyto' | 'sex_shop'
  spe?: string
  isSmartfit?: boolean
}

export const EMAIL_UNAVAILABLE_ERROR = 'O e-mail já foi utilizado'

export const checkEmailAvailability = createAsyncThunk(
  'check-email-availability',
  async (
    { email, firstName, lastName, ssn, phoneNumber, source, spe, isSmartfit }: CheckEmailAvailabilityParams,
    { dispatch, rejectWithValue }
  ) => {
    const isIronberg = getCookies('isIronberg')?.isValid

    const apiParams = decamelizeKeys({
      email,
      firstName,
      lastName,
      ssn,
      phoneNumber,
      source,
      spe,
      ...(isSmartfit && { is_smart_fit: true }),
      ...(isIronberg && { is_ironberg: true })
    })
    try {
      const { data } = await railsApiService.apiInstance.get<{ webdiet_atm_hash?: string }>(
        '/api/v1/users/check_email_availability',
        { params: apiParams }
      )

      if (source === 'consultation' && data?.webdiet_atm_hash) {
        dispatch(setAtmHash(data.webdiet_atm_hash))
      }

      // This returns nothing if email is available

      return true
    } catch (error) {
      return rejectWithValue(EMAIL_UNAVAILABLE_ERROR)
    }
  }
)
